import { render, staticRenderFns } from "./sp-sidebar.vue?vue&type=template&id=5d04be7e"
import script from "./sp-sidebar.vue?vue&type=script&lang=js"
export * from "./sp-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports